import { render, staticRenderFns } from "./AggregateRule.vue?vue&type=template&id=45bdf0d8&scoped=true&"
import script from "./AggregateRule.vue?vue&type=script&lang=ts&"
export * from "./AggregateRule.vue?vue&type=script&lang=ts&"
import style0 from "./AggregateRule.vue?vue&type=style&index=0&id=45bdf0d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bdf0d8",
  null
  
)

export default component.exports